module.exports = __webpack_public_path__ + "img/icon-insta.74c40552.svg";